module.exports = __webpack_public_path__ + "img/cover.da3e1485.png";